import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';

interface ErrorMessageProps extends TypographyProps {
    message?: string; // Optional message prop
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, ...props }) => {
    return (
        <Typography variant="caption" display="block" gutterBottom color="red" {...props}>
            {message}
        </Typography>
    );
};

ErrorMessage.defaultProps = {
    message: 'Please input future Date and Time',
};

export default ErrorMessage;
